import ApplicablePaymentItem from '../Domain/ApplicablePaymentItem';
import ClientPaymentItem from '../Domain/ClientPaymentItem';
import PrePaymentPaymentItem from '../Domain/PrePaymentPaymentItem';
import dateTimeHelper from '../Helpers/datetimeHelper';
import AuthService from './authService';
import SearchParams from '../Elements/SearchParams';
import ClientPaymentsSearchParams from '../Contents/Finance/ClientPayment/ClientPaymentsSearchParams';

export default class ClientPaymentService {
  static GetPaymentsBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    searchItem.EntryAfter = dateTimeHelper.toYYYYsMMsDD(searchItem.EntryAfter);
    searchItem.EntryBefore = dateTimeHelper.toYYYYsMMsDD(searchItem.EntryBefore);
    searchItem.PaymentInstrumentAfter = dateTimeHelper.toYYYYsMMsDD(searchItem.PaymentInstrumentAfter);
    searchItem.PaymentInstrumentBefore = dateTimeHelper.toYYYYsMMsDD(searchItem.PaymentInstrumentBefore);
    const searchParams = new SearchParams(
      searchItem,
      ClientPaymentsSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );

    const url = `/api/ClientPayment/GetClientPaymentAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertPaymentDBItems(itemlist) {
    let mappedItems = [];

    if (itemlist !== null) {
      mappedItems = itemlist.map((item) => new ClientPaymentItem(item));
    }

    return mappedItems;
  }

  static ConvertApplicablePaymentDBItems(itemlist) {
    let mappedItems = [];

    if (itemlist !== null) {
      mappedItems = itemlist.map((item) => new ApplicablePaymentItem(item));
    }

    return mappedItems;
  }

  static GetPrePaymentPaymentsBySearching(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = {
      Command: '',
      OrderBy: orderById,
      OrderDirection: orderDir,
      PageNumber: pageNumber,
      NumberOfElementsOnAPage: numberOfElements,
      SearchItem: searchItem,
    };

    const url = `/api/VZeusLineItemApplied/GetPrepaymentPaymentsAsync/?searchParams=${JSON.stringify(
      searchParams
    )}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertPrePaymentPaymentDBItems(itemlist) {
    let mappedItems = [];

    if (itemlist !== null) {
      mappedItems = itemlist.map((item) => new PrePaymentPaymentItem(item));
    }

    return mappedItems;
  }

  static GetByPaymentId(id) {
    return AuthService.getInstance().CallBackendFunction(`/api/ClientPayment/GetById/${id ? id : 0}`);
  }

  static ApplyPayment(applyItem) {
    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/ClientPayment/ApplyPaymentAsnyc',
      JSON.stringify(applyItem)
    );
  }

  static RemovePayment(removeItem) {
    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/ClientPayment/RemovePaymentAsnyc',
      JSON.stringify(removeItem)
    );
  }

  static GetApplicablePayments(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = {
      Command: '',
      OrderBy: orderById,
      OrderDirection: orderDir,
      PageNumber: pageNumber,
      NumberOfElementsOnAPage: numberOfElements,
      SearchItem: searchItem,
    };

    const url = `/api/ClientPayment/GetAppliablePaymentsAsync/?searchParams=${JSON.stringify(
      searchParams
    )}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static CreateClientPayment(createItem) {
    if (createItem.CpDocdate) createItem.CpDocdate = dateTimeHelper.toYYYYsMMsDD(createItem.CpDocdate);
    const clientPaymentJson = JSON.stringify(createItem);

    return AuthService.getInstance().CallBackendFunctionPost(
      '/api/ClientPayment/CreatePaymentAsync/',
      clientPaymentJson
    );
  }

  static CreateClientPaymentRefund(createItem) {
    createItem.RefundedOn = dateTimeHelper.toYYYYsMMsDD(createItem.RefundedOn);
    const paymentRefundJson = JSON.stringify(createItem);

    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/ClientPayment/CreatePaymentRefundAsync/',
      paymentRefundJson
    );
  }

  static ReversePayment(selectedId, comment) {
    return AuthService.getInstance().CallBackendFunctionPut(
      `/api/ClientPayment/ReversePaymentAsync/${selectedId}`,
      JSON.stringify(comment)
    );
  }
}
